import { z } from 'zod';

import type { PdfDataSnapshot } from '../types/Statements.types';

const pdfTransactionCategorySchema = z
  .object({
    transactions: z.array(
      z.object({
        posted_date: z.string().optional(),
        transaction_date: z.string().optional(),
        description: z.string().optional(),
        amount: z.string().optional(),
      }),
    ),
    count: z.number().optional(),
    subtotal: z.string().optional(),
  })
  .optional()
  .catch(undefined);

export const pdfDataSnapshotSchema: z.ZodType<PdfDataSnapshot, z.ZodTypeDef, unknown> = z.object({
  account_activity: z
    .object({
      purchases: pdfTransactionCategorySchema,
      payments: pdfTransactionCategorySchema,
      fees: pdfTransactionCategorySchema,
      interest: pdfTransactionCategorySchema,
      drawdowns: pdfTransactionCategorySchema,
      total_transactions: z.string().optional().catch(undefined),
    })
    .optional(),
});
